import {
  ExecuteWorkflowToolResultMetadataSchema,
  type ExecuteWorkflowToolResultMetadataType,
} from "@validereinc/domain";

/**
 * Parses terminal execute_workflow tool result metadata on investigation messages.
 */
export const parseExecuteWorkflowToolResultMetadata = (
  metadata: Record<string, unknown> | null | undefined
): ExecuteWorkflowToolResultMetadataType | undefined => {
  if (metadata === null || metadata === undefined) {
    return undefined;
  }
  const parsed = ExecuteWorkflowToolResultMetadataSchema.safeParse(metadata);
  if (!parsed.success) {
    return undefined;
  }
  return parsed.data;
};
